import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useAnalytics } from '@utils/analytics';
import styles from './SocialList.module.scss';

const iconFacebook = require('./assets/images/icons/facebook.svg');
const iconInstagram = require('./assets/images/icons/instagram.svg');
const iconTwitter = require('./assets/images/icons/twitter.svg');
const iconYoutube = require('./assets/images/icons/youtube.svg');

export const SocialList = ({ items, className }) => {
  const { trackInteraction } = useAnalytics();
  const getIcon = type => {
    switch (type) {
      case 'facebook':
        return iconFacebook;
      case 'instagram':
        return iconInstagram;
      case 'twitter':
        return iconTwitter;
      case 'youtube':
        return iconYoutube;
      default:
        return null;
    }
  };

  return (
    <ul className={classNames(styles.list, className)}>
      {items.map(item => (
        <li key={item.drupal_id} className={styles.item}>
          <a
            className={styles.link}
            href={item.field_social_media_link.uri}
            rel="noopener noreferrer"
            target="_blank"
            onClick={() =>
              trackInteraction(
                'social',
                item.field_social_media_type,
                item.field_social_media_link.uri,
                'side-navigation'
              )
            }
          >
            <img
              src={getIcon(item.field_social_media_type).default}
              className={styles.icon}
              alt={`icon ${item.field_social_media_type}`}
            />
          </a>
        </li>
      ))}
    </ul>
  );
};

SocialList.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

SocialList.defaultProps = {
  className: null,
};
